import logo from './assets/shared/logo.svg';
import openM from './assets/shared/icon-hamburger.svg';
import closeM from './assets/shared/icon-close.svg'; 
import homeBgMb from './assets/home/background-home-mobile.jpg';
import homeBgTb from './assets/home/background-home-tablet.jpg';
import homeBgDs from './assets/home/background-home-desktop.jpg';

/* ==== Share ==== */
export const logoST = logo;
export const menuOpen = openM;
export const menuClose = closeM;

/* ==== Backgrounds ====== */
/* Home Background */
export const homeMb = homeBgMb;
export const homeTb = homeBgTb;
export const homeDs = homeBgDs;